<template>
    <DashboardHeader />
    <DashboardStatsSummary />
    <DashboardActions />
    <DashboardLabels />

    <section class="container-fluid content-type-37 side-by-side" v-if="showTagsOwners">
        <div class="container">
            <div class="row">
                <DashboardTags ref="tags" @update-visibility="updateVisibility" />
                <DashboardOwners ref="owners" @update-visibility="updateVisibility" />
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState } from 'pinia';
    import { useAccountStore } from '@/stores/account';
    import DashboardHeader from '@/components/account/dashboard/DashboardHeader';
    import DashboardStatsSummary from '@/components/account/dashboard/DashboardStatsSummary'
    import DashboardLabels from '@/components/account/dashboard/DashboardLabels';
    import DashboardTags from '@/components/account/dashboard/DashboardTags';
    import DashboardOwners from '@/components/account/dashboard/DashboardOwners';
    import DashboardActions from '@/components/account/dashboard/DashboardActions';

    export default {
        name: 'DashboardManager',
        components: {
            DashboardHeader,
            DashboardStatsSummary,
            DashboardLabels,
            DashboardTags,
            DashboardOwners,
            DashboardActions
        },
        computed: {
            ...mapState(useAccountStore, ['stats']),
        },
        data() {
            return {
                showTagsOwners: true
            }
        },
        methods: {
            updateVisibility() {
                const tags = !this.$refs.tags || this.$refs.tags.hide;
                const owners = !this.$refs.owners || this.$refs.owners.hide;
                const hide = tags && owners;
                this.showTagsOwners = !hide;
            }
        }
    };
</script>
